export default __webpack_public_path__ + "static/media/logo-webresources.2127a87f.png";